import * as studentProfile from './student-profile'
import * as general from './general'

export const formHelper = {
  studentProfile,
  general,
}
